export const variableName = {
    outerHeaderName: 'SUPRABHAT PHARMACEUTICALS PVT LTD',
    outer: {
        footerName: 'SUPRABHAT PHARMACEUTICALS PVT LTD',
        address: [
            "Vijayapura, Karnataka",
            "GST - 29ABNCS2478R1Z4",
        ],
        right: {
            liContent: [
                "Banashankari Complex",
                "Akkamahadevi St, ",
                "near Anand Hospital, ",
                "Gacchinakatti Colony, ",
                "Vijayapura, Karnataka 586101"

            ]
        }
    }
};